export var DateOperator;
(function (DateOperator) {
    DateOperator["EQUAL"] = "eq";
    DateOperator["GREATER_THAN"] = "gt";
    DateOperator["GREATER_THAN_OR_EQUAL"] = "gte";
    DateOperator["LESS_THAN"] = "lt";
    DateOperator["LESS_THAN_OR_EQUAL"] = "lte";
})(DateOperator || (DateOperator = {}));
;
//# sourceMappingURL=date-operator.js.map